import { render, staticRenderFns } from "./SubTaskList.vue?vue&type=template&id=5f440a47&"
import script from "./SubTaskList.vue?vue&type=script&lang=ts&"
export * from "./SubTaskList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports